<template>
    <el-dialog :before-close="close" :visible.sync="dialog.visible" title="授权明细">
        <el-table :data="list" border>
            <el-table-column align="center" label="月份" prop="month" />
            <el-table-column align="center" label="试⽤用授权通道" prop="trialChannelCount" />
            <el-table-column align="center" label="拼接授权通道" prop="noFusionChannelCount" />
            <el-table-column align="center" label="融合授权通道" prop="fusionChannelCount" />
            <el-table-column align="center" label="触控通道" prop="touchCount" />
            <el-table-column align="center" label="APP控制" prop="appControlCount" />
        </el-table>
    </el-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('agent');

export default {
    computed: {
        ...mapState({
            dialog: state => state.authDetailDialog,
            list: state => state.authDetail,
        }),
    },
    methods: {
        ...mapActions(['changeAuthDetailDialog']),
        close() {
            this.changeAuthDetailDialog({ visible: false });
        },
    },
};
</script>
